import { getRetailMediaCounterpart } from '~/helpers'

import { getWalletNameFilter } from './getWalletNameFilter'

type BuildListParamsArgs = {
  page: number
  perPage: number
  queryFilterWallet: Parameters<typeof getWalletNameFilter>[0]
  sortDirection?: string | null
  sortDirectionDefault?: string | null
  sortKey?: string | null
  sortKeyDefault?: string | null
}

export const buildCheckingAccountListParams = ({
  page,
  perPage,
  queryFilterWallet,
  sortDirection,
  sortDirectionDefault,
  sortKey,
  sortKeyDefault
}: BuildListParamsArgs): ListCheckingAccountRequestParams => {
  const keyAccount = getRetailMediaCounterpart()
  const key = sortKey || sortKeyDefault

  const orderField =
    (sortKey || sortKeyDefault) === 'name' ? `${keyAccount}_name` : key

  const orderType = sortDirection || sortDirectionDefault
  const nameFilter = getWalletNameFilter(queryFilterWallet)

  return {
    page,
    quantity: perPage,
    account_info: true,
    name: nameFilter,
    orderField,
    orderType
  }
}
